<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('milestone.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('milestone.pageTitle'),
            active: true
          }
        ]"
      />
    </div>

    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="ts-flex ts-justify-between">
            <div class="ts-flex ts-space-x-3">
              <ts-button outline color="info" @click.prevent="onCreate">
                {{ $t('add_new') }}
              </ts-button>
            </div>
          </div>
        </ts-card-wrapper>
        <ts-table-filter
          :columns="milestoneColumns"
          :data="resources"
          @search="search"
        >
          <template slot-scope="{ row }" slot="name">
            <div
              @click.prevent="onView(row)"
              class="ts-text-blue-400 ts-cursor-pointer"
            >
              {{ row.milestone_name }}
            </div>
          </template>
          <template slot-scope="{ row }" slot="estimated_start_date">
            {{ row.estimated_start_date }}
          </template>
          <template slot-scope="{ row }" slot="estimated_end_date">
            {{ row.estimated_end_date }}
          </template>
          <template slot-scope="{ row }" slot="owner_name_en">
            {{ row.owner_name_en }}
          </template>
          <template slot-scope="{ row }" slot="project_status">
            {{ row.project_status }}
          </template>
          <template slot-scope="{ row }" slot="created_at">
            {{ row.created_at }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <div class="ts-flex ts-space-x-2">
              <a
                href="#"
                class="text-info"
                @click.prevent="onView(row)"
                v-tooltip="$t('view')"
              >
                <Icon type="md-eye" size="20" />
              </a>
              <a
                href="#"
                class="text-primary"
                @click.prevent="onEdit(row)"
                v-tooltip="$t('edit')"
              >
                <Icon type="ios-create" size="20" />
              </a>
              <a
                href="#"
                class="text-danger"
                v-tooltip="$t('delete')"
                @click="deleteRecord(row)"
                :disabled="row._deleting"
              >
                <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
                <Icon type="ios-trash" size="20" v-else />
              </a>
            </div>
          </template>
        </ts-table-filter>
        <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
          <ts-i-pagination
            v-model="pagination"
            @navigate="fetchData"
          ></ts-i-pagination>
        </div>

        <IviewModal v-model="isCreateMileStone" title="Create Milestone">
          <CreateMileStone
            v-if="isCreateMileStone"
            :projectId="projectId"
            @close="onClose"
            @fetchData="fetchData"
          />
        </IviewModal>
        <IviewModal v-model="isUpdateMileStone" title="Update Milestone">
          <UpdateMileStone
            v-if="isUpdateMileStone"
            @close="onClose"
            @fetchData="fetchData"
            :edit_data="edit_data"
          />
        </IviewModal>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import IviewModal from '../components/i-modal-wrapper.vue'
import CreateMileStone from '../project-profile/components/create-milestone.vue'
import UpdateMileStone from '../project-profile/components/update-milestone.vue'
export default {
  name: 'mileStoneTable',
  components: {
    CreateMileStone,
    UpdateMileStone,
    IviewModal
  },
  data() {
    return {
      loading: false,
      edit_data: undefined,
      isCreateMileStone: false,
      isUpdateMileStone: false,
      projectId: undefined,
      milestones: []
    }
  },
  computed: {
    ...mapState('projectMgt/projectMilestone', ['resources', 'pagination']),
    milestoneColumns() {
      return [
        {
          title: 'Project Name',
          key: 'project_name',
          minWidth: 90,
          keySearch: 'project_name'
        },
        {
          title: 'Name',
          slot: 'name',
          minWidth: 80,
          keySearch: 'milestone_name'
        },
        {
          title: 'Estemate Start Date',
          slot: 'estimated_start_date',
          minWidth: 80
        },
        {
          title: 'Estemate End Date',
          slot: 'estimated_end_date',
          minWidth: 80
        },
        {
          title: 'Owner Name',
          slot: 'owner_name_en',
          minWidth: 80,
          keySearch: 'owner_name_en'
        },
        {
          title: 'Status',
          slot: 'project_status',
          minWidth: 80
        },
        {
          title: 'Created At',
          slot: 'created_at',
          minWidth: 80
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 150
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('projectMgt/projectMilestone', ['destroy', 'fetch']),
    search(newValue) {
      this.$store.commit('projectMgt/projectMilestone/SET_SEARCH', newValue)
      this.$store.commit('projectMgt/projectMilestone/RESET_CURRENT_PAGE')
      this.fetchData()
    },
    onCreate() {
      this.isCreateMileStone = true
      this.projectId = this.$route.params.id ? this.$route.params.id : undefined
    },
    onClose() {
      this.edit_data = undefined
      this.isCreateMileStone = false
      this.isUpdateMileStone = false
    },
    onEdit(data) {
      this.edit_data = data
      this.isCreateMileStone = false
      this.isUpdateMileStone = true
    },
    deleteRecord(record) {
      record._deleting = true
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.destroy(record.milestone_id)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
            })
            .catch(error => {
              this.$toasted.error(error.message)
            })
            .finally(() => {
              record._deleting = false
            })
        },
        onCancel() {}
      })
    },
    onView(record) {
      this.$router.push({
        name: 'project-milestone-view',
        params: {
          project_id: record.project_id,
          milestone_id: record.milestone_id
        }
      })
    },
    fetchData(attributes) {
      this.milestones = undefined
      this.loading = true
      this.fetch(attributes)
        .then(response => {
          this.milestones = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
